import React, { useState, useEffect } from 'react';
import '../Styles/SessionTimeoutWarning.css';

const SessionTimeoutWarning = ({ onStayLoggedIn, onLogout }) => {
    const [showWarning, setShowWarning] = useState(false);
    const [timeLeft, setTimeLeft] = useState(60);

    useEffect(() => {
        const checkTimeout = setInterval(() => {
            if (window.sessionTimeout) {
                setShowWarning(window.sessionTimeout.showWarning);
                setTimeLeft(window.sessionTimeout.timeLeft);
            }
        }, 1000);

        return () => clearInterval(checkTimeout);
    }, []);

    if (!showWarning) return null;

    const progressPercentage = (timeLeft / 60) * 100;
    const isUrgent = timeLeft <= 15;

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div className="session-warning-overlay">
            <div className={`session-warning-modal ${isUrgent ? 'urgent' : ''}`}>
                <div className="warning-header">
                    <div className={`warning-icon ${isUrgent ? 'urgent' : ''}`}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
                            <path d="M12 9v4"/>
                            <path d="m12 17 .01 0"/>
                        </svg>
                    </div>
                    <h3 className="warning-title">Session Expiring Soon</h3>
                    <p className="warning-subtitle">Your session will timeout due to inactivity</p>
                </div>

                <div className={`timer-section ${isUrgent ? 'urgent' : ''}`}>
                    <div className={`timer-display ${isUrgent ? 'urgent' : ''}`}>
                        {formatTime(timeLeft)}
                    </div>
                    <div className="timer-label">Time remaining</div>
                </div>

                <div className="progress-container">
                    <div className="progress-bar">
                        <div 
                            className={`progress-fill ${isUrgent ? 'urgent' : ''}`}
                            style={{ width: `${progressPercentage}%` }}
                        />
                    </div>
                </div>

                <p className="warning-message">
                    To continue your session, please click "Stay Logged In" below. 
                    Otherwise, you will be automatically logged out for security.
                </p>

                <div className="button-group">
                    <button 
                        onClick={onStayLoggedIn}
                        className="session-btn session-btn-primary"
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
                        </svg>
                        <span>Stay Logged In</span>
                    </button>

                    <button 
                        onClick={onLogout}
                        className="session-btn session-btn-secondary"
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                            <polyline points="16,17 21,12 16,7"/>
                            <line x1="21" x2="9" y1="12" y2="12"/>
                        </svg>
                        <span>Logout</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionTimeoutWarning;